'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = promiseMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function promiseMiddleware(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;

  return function (next) {
    return function (action) {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      var promise = action.promise,
          type = action.type,
          meta = action.meta,
          rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'type', 'meta']);


      if (!promise) {
        return next(action);
      }

      // payload we assume to be a function that returns
      // a promise. other libraries might override this,
      // in which case additional checks could be done
      // here.

      var PENDING = type + '_PENDING';
      var FULFILLED = type + '_FULFILLED';
      var REJECTED = type + '_REJECTED';

      // continue on through the middleware stack
      next((0, _extends3.default)({}, rest, { meta: meta, type: PENDING }));

      return promise().then(function (response) {
        next((0, _extends3.default)({}, rest, { meta: meta, response: response, type: FULFILLED }));
      }).catch(function (error) {
        // Picks up errors in parsing
        console.log(error);
        next((0, _extends3.default)({}, rest, { meta: meta, error: error, type: REJECTED }));
      });
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/promise.js
// module id = 1301
// module chunks = 0